import { render, staticRenderFns } from "./DoctorHeader.vue?vue&type=template&id=4358e8a9"
import script from "./DoctorHeader.vue?vue&type=script&lang=js"
export * from "./DoctorHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports